// extracted by mini-css-extract-plugin
module.exports = {"star":"star_star__3FUks"};